const leaders = [
  {
    img: '/img/leader-slide2.png',
    name: 'Vijay Akasapu',
    job: 'CEO',
    text: 'More than two decades with Foundstone, Mandiant and FireEye leading services and R&D in EDR and SIEM technologies with a passion for helping companies manage risk.',
    style: {

    }
  },
  {
    img: '/img/julio.png',
    name: 'Julio Escobar',
    job: 'CFO',
    text: 'Three decades of experience as an innovator, executive, entrepreneur and policy maker. Founder and co-founder of two technology companies. Believes in talent and motivation to drive innovation.',
    style: {
      opacity: 0.8
    }
  },
  {
    img: '/img/leader-slide5.png',
    name: 'Eric Cornelius',
    job: 'CTO',
    text: 'Two decades of hands-on engineering experience and technical leadership working in digital media, finance, and cybersecurity domains.',
    style: {
      backgroundPositionY: 'center'
    }
  }
];

export default leaders;

